module.exports = __webpack_public_path__ + "static/media/visa-mastercard.3f49f6c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment/kz_pay/visa-mastercard.svg
// module id = 889
// module chunks = 7